export default __webpack_public_path__ + "static/media/logo-black.0c211466.png";